import { render, staticRenderFns } from "./AttachmentUploadDialog.vue?vue&type=template&id=f6af3148&scoped=true"
import script from "./AttachmentUploadDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploadDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentUploadDialog.vue?vue&type=style&index=0&id=f6af3148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af3148",
  null
  
)

export default component.exports